import axios from 'axios';
import backendAxios from '../utils/backendAxios';

import { USERS_ERROR, GET_USER, GET_USERS, CLEAR_USER, TOGGLE_FAVORITE, LOGOUT_CLIENT } from './types';
import { URL } from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

/***************RECUPERAR CONTRASEÑA******************/

export const checkUser = async dato => {
  try {
    const res = await axios.get(`${URL}/api/users/telemail/${dato}`,);
    return res.data;
  } catch (err) {
    console.error(err, "Error en checkUser");
    return false;
  }
}

//Obtener código por SMS o por Email (2025)
export const getCode = async (emailTel, data) => {
  try {
    if (emailTel === "celular") {
      const res = await axios.get(`${URL}/api/users/phone?phonenumber=${data.tel}&channel=sms&forgotpass=true`);
      return res.data;
    } else {
      const res = await axios.post(`${URL}/api/users/send/email`, data);
      return res.data;
    }

  } catch (err) {
    console.error(err, "Error al enviar el código (getCode)");
    return false;
  }
}

//Revisar código por SMS (2025)
export const checkCode = async (formData, addUser = false) => {
  try {
    const res = await axios.get(`${URL}/api/users/verify?phonenumber=${formData.phonenumber}&code=${formData.code}`);
    if (addUser) {
      return res.data
    }
    if (res.data.status === 'approved' && res.data.valid === true) {
      return true
    }
  } catch (err) {
    console.error(err, "Error al verificar el código (checkCode)");
    return false;
  }
}

// Cambiar password en olvidar contraseña (2025)
export const changePassForgot = async (formData, id) => {
  try {
    await axios.patch(`${URL}/api/users/client/pass/forgot/${id}`, formData, config);
    return true;
  } catch (err) {
    console.error(err, "Error al cambiar la contraseña (changePassForgot)");
    return false;
  }
}

//Enviar código por SMS en Crear Cuenta(SMS 2025)
export const sendCode = async (infoUser, aDonde, history) => {
  try {
    const res = await axios.get(`${URL}/api/users/phone?phonenumber=${infoUser.num}&channel=sms`);
    if (aDonde !== '') {
      history(aDonde, {
        state: {
          to: res.data.to,
          infoUser,
          emailTel: "celular"
        }
      });
    }
  } catch (err) {
    console.error(err, "Error al enviar el código (sendCode)");
    return false;
  }
}

//Enviar código por email (2025)
export const sendCodeEmail = async data => {
  try {
    const res = await axios.post(`${URL}/api/users/send/email`, data);
    return res;

  } catch (err) {
    console.error(err, "Error al enviar el email (sendCodeEmail)");
    return false;
  }
}


/****************REGISTRO****************/

//Verificar email (2025)
export const checkEmail = async email => {
  try {
    await axios.get(`${URL}/api/users/email/${email}`);
    return true;
  } catch (err) {
    console.error(err, "Error en checkEmail");
  }
}

// Agregar usuario en crear cuenta (2025)
export const addUser = async (formData, history) => {
  try {
    await axios.post(`${URL}/api/users/client`, formData, config);
    history('/signup-last', {
      state: {
        status: 'success'
      }
    });
  } catch (err) {
    console.error("Error en addUser(actions)");
  }
}

// Obtener usuario por el ID (2025)
export const getUserbyId = async id => {
  try {
    const res = await backendAxios.get(`/api/users/client/${id}`);
    return res.data;
  } catch (err) {
    console.error(err, "Error al obtener el usuario");
  }
}


/***********************PERFIL***********************/

// Nota: la verificación (RFC/CURP/documentos) se maneja directo en
// components/user/tabs/Documentos.js contra /api/users/client/verificacion/*

// Get user
export const getUser = id => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/users/client/${id}`);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: USERS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

// Edita el avatar del usuario (2025)
export const editAvatar = image => async dispatch => {
  try {
    dispatch(uploadAvatar(image));
  } catch (err) {
    console.error("Error en editAvatar actions", err);
    dispatch({
      type: USERS_ERROR
    });
  }
}

// Edita el nombre y el apellido, fecha de nacimiento y sexo del usuario (2025)
export const editDatosPersonales = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/users/client/edit/${id}`, formData);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    console.error(err, "Errors");
    dispatch({
      type: USERS_ERROR
    });
  }
}

// Edita si se comparte la info del usuario (2025)
export const editShare = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/users/client/share/${id}`, formData);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    console.error(err, 'Error al editShare');
    dispatch({
      type: USERS_ERROR
    });
  }
}

// Editar email del usuario (2025)
export const editEmail = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/users/client/email/${id}`, formData);
    dispatch({
      type: GET_USER,
      payload: res.data
    });
  } catch (err) {
    console.log("Error en editEmail", err);
    dispatch({
      type: USERS_ERROR
    });
  }
}

// cambiar password del usuario logueado (2025)
export const changePass = async (formData) => {
  try {
    await backendAxios.patch(`/api/users/client/pass`, formData);
    return true;
  } catch (err) {
    console.error("Error en changePass", err);
  }
}

//Verifica el numero de celular del usuario y lo guarda en la base datos (2025)
export const verifySavePhone = (formData, id) => async dispatch => {
  try {
    const res = await axios.get(`${URL}/api/users/verify?phonenumber=${formData.tel}&code=${formData.code}`);
    if (res.data.status === 'approved' && res.data.valid === true) {
      const result = await backendAxios.patch(`/api/users/client/phone/${id}`, formData);
      dispatch({
        type: GET_USER,
        payload: result.data
      });
      return true;
    }
  } catch (err) {
    console.error(err, "Error al verificar y guardar el teléfono (verifySavePhone)", err);
    dispatch({
      type: USERS_ERROR,
    });
  }
}

// Upload del avatar y guarda la version en la BD (2025)
export const uploadAvatar = formData => async dispatch => {
  try {
    formData.append("usuario", true);
    // backendAxios (no axios puro) para que viaje el x-auth-token: el endpoint /upload
    // ahora exige sesión. El Content-Type multipart explícito evita que axios convierta
    // el FormData a JSON (comportamiento por el default application/json de backendAxios).
    const res = await backendAxios.post(`/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    const arr = res.data.public_id.split('/');
    const info = {
      version: res.data.version,
      // Nombre del archivo subido (= user._id, con el que se guarda en Cloudinary).
      // Antes se mandaba 'ava', que el backend interpretaba como "no cambiar el avatar",
      // por lo que user.avatar se quedaba con la URL de gravatar y la foto nunca se veía.
      avatar: arr[arr.length - 1]
    }

    const response = await backendAxios.patch(`/api/users/client/avatar/${arr[1]}`, info);
    dispatch({
      type: GET_USER,
      payload: response.data
    });
  } catch (err) {
    dispatch({
      type: USERS_ERROR,
      payload: err.response.data.msg
    });
  }
}

// Search users
export const searchUsers = busqueda => async dispatch => {
  try {
    const res = await backendAxios.get(`/api/users/client/search/${busqueda}`);
    dispatch({
      type: GET_USERS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: USERS_ERROR,
      payload: { msg: err.response?.statusText || "Server Error", status: err.response?.status || 500 }
    });
  }
}

//Clear user profile
export const clearUser = () => async dispatch => {
  try {
    dispatch({
      type: CLEAR_USER,
    });
  } catch (err) {
    console.error(err);
  }
}
// Favoritos (2025)
export const toggleFavorite = (serviceId) => async dispatch => {
  try {
    const res = await backendAxios.post(`/api/users/favorite/${serviceId}`);
    dispatch({
      type: TOGGLE_FAVORITE,
      payload: res.data
    });
  } catch (err) {
    console.error(err, "Error al toggleFavorite");
    dispatch({
      type: USERS_ERROR,
      payload: { msg: "Error al agregar a favoritos", status: 500 }
    });
  }
}

// Eliminar cuenta de usuario (Borrado Híbrido)
export const deleteAccount = (history) => async dispatch => {
  try {
    await backendAxios.delete(`/api/users/`);
    dispatch({ type: CLEAR_USER });
    dispatch({ type: LOGOUT_CLIENT });
    history('/');
  } catch (err) {
    console.error(err, "Error al eliminar cuenta");
    dispatch({
      type: USERS_ERROR,
      payload: { msg: "Error al eliminar cuenta", status: 500 }
    });
  }
}
